module.exports = __webpack_public_path__ + "static/media/400013_02.93f12756.png";